import {initSelects, initLoadMoreObjects, initFiltersPanel, initEvents, insertMiniSupportBlock} from './common';

initSelects();
initFiltersPanel();
initLoadMoreObjects();
initEvents();
insertMiniSupportBlock();
